import _groupBy from 'lodash/groupBy'
import _orderBy from 'lodash/orderBy'
import _sortBy from 'lodash/sortBy'
import useAuditSourcesStore from 'frontend/store/sources/useAuditSourcesStore'
import {
  getPersonNotifications,
} from 'frontend/communications/apiClient'


function getModules (getters) {
  const auditSourcesStore = useAuditSourcesStore()
  const modules = [
    'improvementIdeas',
    'standard_work_audits',
  ]
  if (getters.hasActions) {
    modules.push('actions')
    modules.push('escalated_actions')

  }
  if (getters.hasAlerts) {
    modules.push('alerts')
  }
  if (getters.hasProblemSolving) {
    modules.push('problems')
    modules.push('presentations')
  }
  if (auditSourcesStore.auditSources.length > 0) {
    modules.push('audits')
    modules.push('audits_to_sign')
  }
  if (getters.hasStandardViewer) {
    modules.push('myStandards')
  }
  if (getters.hasStandardViewer && getters.userHasAnyApprovalPermission) {
    modules.push('pendingStandards')
  }
  if (!getters.getIsCorporate) {
    modules.push('diagnosis')
    modules.push('consolidated_reports')
  }
  if (getters.isHSERiskModuleEnabled) {
    modules.push('hseRisks')
  }
  return modules
}

const stateObj = {
  pendingItems: [],
  numberOfpendingItems: 0,
}

const moduleGetters = {
  getPendingItems (state) {
    return state.pendingItems
  },
  getNumberOfPendingItems (state) {
    return state.numberOfpendingItems
  },
}

const mutations = {
  setPendingItems (state, value) {
    state.pendingItems = value
  },
  setNumberOfPendingItems (state, value) {
    state.numberOfpendingItems = value
  },
}

const actions = {
  fetchPersonNotifications ({ commit, getters }) {
    const modules = getModules(getters)
    return getPersonNotifications({ 'modules': modules, 'format': 'count' }).then((total) => {
      commit('setNumberOfPendingItems', total['total'])
    }).catch()
  },
  async fetchPendingItems ({ commit, getters } ) {
    const modules = getModules(getters)
    if (modules.length === 0) {
      return
    }
    
    const notifications = await getPersonNotifications({ 'modules': modules })
    
    const pendingItems = []
    if (modules.includes('actions')) {
      pendingItems.pendingActions = _orderBy(notifications['actions'], ['when'], ['asc'])
    }
    if (modules.includes('escalated_actions')) {
      pendingItems.escalatedActions = _orderBy(notifications['escalated_actions'], ['when'], ['asc'])
    }
    if (modules.includes('alerts')) {
      pendingItems.pendingAlerts = _orderBy(notifications['alerts'], ['when'], ['asc'])
    }
    if (modules.includes('improvementIdeas')) {
      pendingItems.pendingImprovementIdeas = _orderBy(notifications['improvement_ideas'], ['when'], ['asc'])
    }
    if (modules.includes('problems')) {
      pendingItems.pendingProblems = notifications['problems']
    }
    if (modules.includes('presentations')) {
      pendingItems.pendingPresentations = _orderBy(notifications['presentations'], ['when'], ['asc'])
    }
    if (modules.includes('audits') || modules.includes('audits_to_sign')) {
      const auditSourcesStore = useAuditSourcesStore()
      const orderedAuditSources = auditSourcesStore.auditSourcesSorted.map((source) => source.name)
      const auditsDictionary = _groupBy(notifications['audits'], 'source_orig')
      const sortedAudits = Object.keys(auditsDictionary).filter(item => orderedAuditSources.includes(item)).map((item) => { return auditsDictionary[item] })
      pendingItems.pendingAudits = _sortBy(sortedAudits, audit => {
        return orderedAuditSources.indexOf(audit[0].source_orig)
      })
      const auditsToSignDictionary = _groupBy(notifications['audits_to_sign'], 'source_orig')
      const sortedAuditsToSign = Object.keys(auditsToSignDictionary).filter(item => orderedAuditSources.includes(item)).map((item) => { return auditsToSignDictionary[item] })
      pendingItems.pendingAuditsToSign = _sortBy(sortedAuditsToSign, audit => {
        return orderedAuditSources.indexOf(audit[0].source_orig)
      })
    }
    if (modules.includes('myStandards') || modules.includes('pendingStandards')) {
      pendingItems.validationPendingStandards = _orderBy(notifications['pending_standards'], ['when'], ['asc'])
      pendingItems.myStandards = _orderBy(notifications['my_standards'], ['when'], ['asc'])
    }
    if (modules.includes('diagnosis')) {
      pendingItems.pendingDiagnoses = _orderBy(notifications['diagnosis'], ['when'], ['asc'])
    }
    if (modules.includes('consolidated_reports')) {
      pendingItems.pendingConsolidatedReports = _orderBy(notifications['consolidated_reports'], ['when'], ['asc'])
    }
    if (modules.includes('standard_work_audits')) {
      pendingItems.pendingStandardWorkAudits = _orderBy(notifications['standard_work_audits'], ['when'], ['asc'])
    }
    if (getters.isHSERiskModuleEnabled) {
      pendingItems.hseRisks = _orderBy(notifications['hse_risks'], ['when'], ['asc'])
    }
    commit('setPendingItems', pendingItems)
  },
}

export default {
  state: stateObj,
  getters: moduleGetters,
  mutations,
  actions,
}
